var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-range',{attrs:{"selected-date-from":_vm.selectedDateFrom,"selected-date-to":_vm.selectedDateTo,"periodFrom":_vm.makePeriod('month', true),"periodTo":_vm.makePeriod('month', false)},on:{"changed-dates":_vm.changedDates}})}
var staticRenderFns = []

export { render, staticRenderFns }